export enum PauseProspectOption {
  PauseProspectManually = 'ooo-pause-prospect-manually',
  PauseProspectAsPerReturnDate = 'ooo-pause-prospect-as-per-return-date',
}
